import { GeneralCompany } from '../../components/general-company/GeneralCompany';

export function MyCompanyPage() {
  return <GeneralCompany></GeneralCompany>;
}
